<template>
  <div>
    <h2>ホーム</h2>
    <v-container grid-list-md fluid>
      <div class="menu-row">
        <v-layout row wrap class="menu-wrap">
          <v-flex
            v-for="(item, i) in items.filter(i => {return i.type =='staff'})"
            :key="i"
            xs3
            md2
          >
            <v-hover>
              <v-card
                :to="item.to"
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
                class="mx-auto menu-card"
                width="160"
              >
                <v-card-media class="menu-img">
                  <v-badge right overlap　v-model="item.notifications>0">
                    <v-icon x-large>{{item.icon}}</v-icon>
                    <v-icon v-if="item.type=='boss'">face</v-icon>
                    <v-icon v-if="item.type=='manager'">settings</v-icon>
                  </v-badge>
                </v-card-media>
                <v-card-text class="menu-text">
                  <div class="menu-name">{{item.name}}</div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";

var moment = require("moment");
export default {
  components: {},
  data() {
    return {
      items: [
        {
          icon: "assignment_ind",
          notifications: 1,
          name: "サーベイ結果",
          to: { name: "results" },
          type: "staff"
        },
        {
          icon: "trending_up",
          notifications: 0,
          name: "目標設定",
          to: { name: "targets" },
          type: "staff"
        },
        {
          icon: "assignment_ind",
          notifications: 0,
          name: "部下サーベイ結果",
          type: "boss",
          to: { name: "results" }
        },
        {
          icon: "trending_up",
          notifications: 2,
          name: "部下目標設定",
          type: "boss",
          to: { name: "targets" }
        },
        {
          icon: "assignment_ind",
          notifications: 0,
          name: "サーベイ進捗管理",
          type: "manager",
          to: { name: "manage_surveys" }
        },
        {
          icon: "trending_up",
          notifications: 0,
          name: "目標設定進捗管理",
          type: "manager",
          to: { name: "manage_surveys" }
        }
      ]
    };
  },

  created() {},
  computed: {},
  methods: {}
};
</script>

<style lang="css" scoped>
.menu-card {
  padding: 10px;
  margin-top: 10px;
}
.menu-name {
  text-align: center;
  font-weight: bold;
  font-size: 1.2em;
}
.menu-text {
  margin: 5px;
  padding: 0px;
  width: 90%;
  font-size: 0.8em;
}
.menu-img {
  text-align: center;
  padding: 10px;
}
.menu-wrap {
  border: solid 2px;
  border-radius: 10px;
  padding: 5px;
  margin: 5px 0px;
}
.menu-row {
  margin: 15px 0px;
}
</style>